import React from 'react';
import './index.css';

function PageTitle({ children, className = '', maxWidth, marginBottom }) {
  const style = {};
  if (maxWidth) {
    style.maxWidth = maxWidth;
    style.marginLeft = 'auto';
    style.marginRight = 'auto';
  }
  if (marginBottom !== undefined) {
    style.marginBottom = marginBottom;
  }

  return (
    <div className={`page-title ${className}`} style={style}>
      {children}
      <span className="page-title-dot"></span>
    </div>
  );
}

export default PageTitle;

